import PropArray from './type/propArray';
import useLayer from './layer/useLayer';
import useInjectMethod from './utils/useInjectMedthod';
import useInjectMiddleware from './utils/useInjectMiddleware';
import { discardProps } from './useDiscard';
import useOnLayerSet from './layer/observable/useOnLayerSet';
import useOnLayerGet from './layer/observable/useOnLayerGet';
import useOnLayerAfterSet from './layer/observable/useOnLayerAfterSet';
import useWeakMap from './utils/useWeakMap';
import useMap from './utils/useMap';
import { onChangeBoxDone } from './layer/utils/useChangeBox';


const wrapperCaching = useWeakMap();

const setCaching = (key, instance) => wrapperCaching.set(key, instance);
const getCaching = (key) => wrapperCaching.get(key);
const hasCaching = (key) => wrapperCaching.has(key);


/**
 * Description placeholder
 *
 * @param {import('../t.d').ZoneMiddleWare} mw
 * @param {string} absKey
 */
const canCallMiddlewareSetter = (mw, absKey) => {
    const injectProps = mw.injectProps() || [];
    return (injectProps === '*' || injectProps.includes(absKey)) && typeof mw.provider.setter === 'function'
}

/**
 * Description placeholder
 *
 * @param {import('../t.d').ZoneMiddleWare} mw
 * @param {string} absKey
 */
const canCallMiddlewareGetter = (mw, absKey) => {
    const injectProps = mw.injectProps() || [];
    return (injectProps === '*' || injectProps.includes(absKey)) && typeof mw.provider.getter === 'function'
}

class ZoneWrapper {

    #fnPropChanges;
    #context;
    propRoot = {};
    #layerInstance;
    #stackOriginProps = new Array();
    #propsStacks = useMap();

    #layers = new Set()

    middlewareOutput = {}

    /**
     * Description placeholder
     *
     * @type {{
     *  beforeChanges:{ origin: Array<import('../t.d').ZoneMiddleWare>; ui: Array<import('../t.d').ZoneMiddleWare>; },
     * afterChanges: { origin: Array<import('../t.d').ZoneMiddleWare>; ui: Array<import('../t.d').ZoneMiddleWare>; }
     * }}
     */
    #zoneMiddlewares = {
        beforeChanges: {
            origin: [],
            ui: []
        },
        afterChanges: {
            origin: [],
            ui: []
        }
    }

    zonePropsUI;

    #zoneProp;

    zoneProp;

    constructor(context, defaultProps) {
        this.propRoot = defaultProps;
        this.#context = context;
        this.#init();
    }

    #init() {
        this.#layerInstance = useLayer(this.propRoot);

        this.zonePropsUI = this.#layerInstance.getRootLayer()[0];

        this.#zoneProp = this.#layerInstance.getRootLayer()[0];

        this.zoneProp = this.#layerInstance.getRootLayer()[0];

        this.#bindLayerObserver(this.#zoneProp, this.zonePropsUI);
        this.#initBuildInMiddleware();

    }

    #bindLayerObserver(layer1, layer2) {
        /* Layer 1 */
        // useOnLayerSet(layer1, (propertyPath, absKey, key, value, oldValue) => {
        //     return this.#executeMiddleWareSetter(this.#zoneMiddlewares.beforeChanges.origin, absKey, value, oldValue);
        // })

        // useOnLayerGet(layer1, (propertyPath, absKey, key, value) => {
        //     return this.#executeMiddleWareGetter(this.#zoneMiddlewares.beforeChanges.origin, absKey, value);
        // })

        // useOnLayerAfterSet(this.#zoneProp, (propertyPath, absKey, key, value, oldValue) => {
        //     this.#executeMiddlewareAfterSet(this.#zoneMiddlewares.afterChanges.origin, absKey, value, oldValue)
        // }, '*')

        /* Layer 2 */
        useOnLayerSet(layer2, (propertyPath, absKey, key, value, oldValue) => {
            return this.#executeMiddleWareSetter(this.#zoneMiddlewares.beforeChanges.ui, absKey, value, oldValue);
        })

        useOnLayerGet(layer2, (propertyPath, absKey, key, value) => {
            return this.#executeMiddleWareGetter(this.#zoneMiddlewares.beforeChanges.ui, absKey, value);
        })

        useOnLayerAfterSet(layer2, (propertyPath, absKey, key, value, oldValue) => {
            this.#executeMiddlewareAfterSet(this.#zoneMiddlewares.afterChanges.ui, absKey, value, oldValue);

        }, '*')

        onChangeBoxDone((propertyPath, key, value, oldValue) => {
            const absKey = propertyPath.pathToString();
            this.#emitChanges(absKey, value, oldValue, propertyPath);
        })
    }

    #initBuildInMiddleware() {
        this.injectMiddleware = this.injectMiddleware.bind(this);
        this.middlewareOutput = useInjectMiddleware(this)
    }

    #emitChanges(prop = '', value, oldValue, propertyPath) {
        if (typeof this.#fnPropChanges === 'function')
            this.#fnPropChanges(prop, oldValue, value, propertyPath.toArray())
    }


    #executeMiddleWareSetter(targetMiddleWares, absKey, value, oldValue) {
        for (let i in targetMiddleWares) {
            const mw = targetMiddleWares[i];
            if (canCallMiddlewareSetter(mw, absKey)) {
                value = mw.provider.setter(absKey, value, oldValue);
            }
        }
        return value;
    }

    #executeMiddleWareGetter(targetMiddleWares, absKey, value) {
        /**@type {Array<ZoneMiddleware>} */
        for (let i in targetMiddleWares) {
            const mw = targetMiddleWares[i];
            if (canCallMiddlewareGetter(mw, absKey)) {
                const old = value;
                value = mw.provider.getter(absKey, old);
            }
        }
        return value;
    }

    #executeMiddlewareAfterSet(targetMiddleWares, absKey, value, oldValue) {
        for (let i in targetMiddleWares) {
            const mw = targetMiddleWares[i];
            if (canCallMiddlewareSetter(mw, absKey)) {
                mw.provider.setter(absKey, value, oldValue);
            }
        }
    }

    #doRevertProp() {
        const { getOriginProps } = this.#layerInstance
        const loop = (propertyPath, layer, originProp) => {
            let p, target = layer, lastProp = propertyPath.pop();
            while (propertyPath.length > 0) {
                p = propertyPath.shift();
                if (target.hasOwnProperty(p)) {
                    target = target[p]
                } else {
                    p = null;
                    target = null;
                    break;
                }
            }
            if (p && lastProp && target) {
                target[lastProp] = originProp;
            }
        }
        const origins = getOriginProps();
        while (origins.length > 0) {
            const [propArr, originSource] = origins.shift();
            for (let i in this.#stackOriginProps) {
                loop(propArr, this.#stackOriginProps[i], originSource);
            }
        }
    }

    /**
     * Description placeholder
     * @template T
     * @param {T} prop
     * @returns {T}
     */
    injectProp(prop) {
        const { injectProps } = this.#layerInstance;
        const [sl1, sl2] = injectProps(prop, new PropArray());
        this.#layers.add(sl1);
        this.#layers.add(sl2);
        return [sl1, sl2];
    }

    /**
     * 
     * @param {Object.<string, () =>void >} methods
     */
    injectMethod(methods) {
        const { getRootLayer } = this.#layerInstance;
        const layer1 = getRootLayer()[0];
        useInjectMethod(layer1, methods);
    }

    discardWrapper() {
        const { discardLayer, getRootProps, getOriginalSource } = this.#layerInstance;
        const allLayers = Array.from(this.#layers);
        while (allLayers.length > 0) {
            discardProps(allLayers.shift())
        }
        // this.#doRevertProp();
        // flatKeys.clear();
        if (this.#propsStacks) {
            this.#propsStacks.clear();
            this.#propsStacks = null;
        }
        this.propRoot = null;
        discardLayer();
        wrapperCaching.delete(this.#context);

        const originalSource = getOriginalSource();
        if (originalSource) {
            // Object.assign(this.zoneProp, getOriginalSource());
            // Object.assign(this.propRoot, getOriginalSource());
        }
    }

    /**
     * Description placeholder
     *
     * @param {ZoneMiddleware} middleware
     * @returns {ZoneMiddleWareAction}
     */
    injectMiddleware(middleware) {
        const middlewares = middleware.callWhen == 'afterChanges' ? this.#zoneMiddlewares.afterChanges : this.#zoneMiddlewares.beforeChanges;
        switch (middleware.injectTo) {
            case 'origin':
                if (typeof middleware.grantProp === 'function') {
                    middleware.grantProp(this.#zoneProp)
                }
                middlewares.origin.push(middleware);
                break;
            case 'ui':
                if (typeof middleware.grantProp === 'function') {
                    middleware.grantProp(this.zonePropsUI)
                }
                middlewares.ui.push(middleware);
                break;
        }
        return middleware.action;
    }

    onPropsChanges(cb) {
        this.#fnPropChanges = cb;
    }
}

/**
 * Description placeholder
 *
 * @param {object} context
 * @returns {ZoneWrapper}
 */
const useZoneWrapper = (context, defaultProps = {}) => {
    if (hasCaching(context)) {
        return getCaching(context);
    } else {
        const zoneWrapper = new ZoneWrapper(context, defaultProps);
        const {
            discardWrapper,
            injectMiddleware,
            injectMethod,
            injectProp,
            onPropsChanges,
            zonePropsUI,
            zoneProp,
            middlewareOutput
        } = zoneWrapper;

        const exportInstance = {
            discardWrapper: discardWrapper.bind(zoneWrapper),
            injectMiddleware: injectMiddleware.bind(zoneWrapper),
            injectMethod: injectMethod.bind(zoneWrapper),
            injectProp: injectProp.bind(zoneWrapper),
            onPropsChanges: onPropsChanges.bind(zoneWrapper),
            zonePropsUI,
            zoneProp,
            middlewareOutput
        }
        setCaching(context, exportInstance);
        return exportInstance;
    }
}

export default useZoneWrapper;